import { customType } from 'drizzle-orm/pg-core';
export * from './metrics';
export * from './print-options';
export * from './calendar-print-options';
export * from './layer';
export * from './profile-permissions';
/**
 * Used to declare a json column for an "options" or "config" type. The default value is set to an empty object.
 * Rather than updating the default each time a new property is added, we simply use the defaultsFn to fill in new defaults.
 * This saves us from needing to create migrations for new properties.
 *
 * @param name Name of the column
 * @param defaultsFn A function to fill in defaults for any missing values
 */
export function configColumn(name, defaultsFn) {
    const configType = customType({
        dataType() {
            return 'jsonb';
        },
        toDriver(value) {
            return JSON.stringify(value);
        },
        fromDriver(value) {
            const obj = typeof value === 'string' ? JSON.parse(value) : value;
            return defaultsFn(obj);
        },
    });
    return configType(name).default({});
}
//# sourceMappingURL=index.js.map